exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-container[data-v-128da19f]{background-color:#2c2c2c;height:100px;display:flex;justify-content:center}.footer-row[data-v-128da19f]{display:flex;flex-direction:row;justify-content:space-between;align-items:center;width:100%;text-align:center}.footer-row p[data-v-128da19f]{color:#717171;padding:10px 0;font-family:Helvetica,sans-serif;font-size:16px;margin:0}.copy[data-v-128da19f],.footer-form[data-v-128da19f]{width:50%}.footer-input[data-v-128da19f]{border:none;border-radius:5px 0 0 5px;padding:17px 20px;font-size:20px;width:50%}.footer-button[data-v-128da19f]{border:none;background-color:#2e3192;color:#fff;font-size:20px;padding:17px 30px;border-radius:5px;left:-4px;position:relative}.footer-button[data-v-128da19f]:focus{outline:none}@media(max-width:775px){.footer-row p[data-v-128da19f]{font-size:14px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-128da19f","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Footer.vue
// module id = 239
// module chunks = 0